module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i-box', {
    staticClass: "metric-unit"
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('div', {
    staticClass: "unit-title"
  }, [_c('el-popover', {
    ref: "popover-hint",
    attrs: {
      "content": _vm.description,
      "width": "250",
      "placement": "bottom-end",
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "fa fa-info-circle pull-right",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  })]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.title))])], 1)]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(_vm.type === 'bar') ? _c('bar-chart', {
    staticClass: "content-chart",
    attrs: {
      "data": _vm.chartData,
      "stacked": _vm.stacked,
      "showLegend": _vm.showLegend
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'horizontal-bar') ? _c('horizontal-bar-chart', {
    staticClass: "content-chart",
    attrs: {
      "data": _vm.chartData,
      "stacked": _vm.stacked,
      "showLegend": _vm.showLegend
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aaf06ae6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/social/facebook/metrics/PageViewsItem.vue
// module id = 3378
// module chunks = 3